import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-thank-you-page',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
